import React from 'react';
import { Col, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useOverviewLinkStateActions } from '../hooks/useOverviewLinkStateActions';
import { useOverviewLinkState } from '../linkstate/userOverview.linkstate';

export const SettingFilter = () => {
    const [{ search }] = useOverviewLinkState();
    const { patch: patchState } = useOverviewLinkStateActions();

    return (
        <>
            <Col style={{ width: 360 }}>
                <Input
                    value={search}
                    placeholder={'Search by User name, email, Operator name...'}
                    onChange={(e) => patchState({ search: e.target.value })}
                    addonBefore={<SearchOutlined />}
                />
            </Col>
        </>
    );
};
